import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouseClassic2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMouseClassic2"><Path d="M19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V11H19V15Z" fill="currentColor"/><Path d="M19 9H13V2H19V9Z" fill="currentColor"/><Path d="M11 9H5V2H11V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMouseClassic2;
